import { SelectOptionType } from 'components/Select/Select';
import { ReactElement } from 'react';
import { CountryCodeType, CurrencyType } from 'types/types';
import CountryCode from './CountryCode';
import { currencyCodeMap } from 'data/currencyCodeMap';

export const radioOptions = [
  {
    value: 'yes',
    label: 'Yes',
  },
  {
    value: 'no',
    label: 'No',
  },
];

export const getCountryCodeOptions = (
  countryCodes: CountryCodeType[]
): SelectOptionType[] =>
  countryCodes.map(({ name, code, id }) => ({
    value: id.toString(),
    html: CountryCode({ name, code }) as ReactElement,
  }));

export const getCurrencyOptions = (
  currencies: CurrencyType[],
  { showSymbol = true } = {}
): SelectOptionType[] => {
  return currencies.map(({ code, symbol }) => {
    const name = showSymbol ? `${symbol} - ${code}` : code;

    return {
      value: code,
      name,
    };
  });
};

export const getCurrencyOptionsVoucher = (
  currencies: CurrencyType[]
): SelectOptionType[] => {
  return currencies.map(({ code, symbol }) => {
    const country = currencyCodeMap[code] || '';
    const name = country
      ? `${country} - ${symbol} ${code}`
      : `${symbol} ${code}`;

    return {
      value: code,
      name,
    };
  });
};
